import { colors } from 'ui/theme';
import { CustomCombo } from '../types';

const comboOptions = {
  padding: [40, 20, 20, 20],
  style: {
    fill: 'rgba(181, 109, 198, 0.04)',
    stroke: colors.purple50,
    lineWidth: 2,
    lineDash: [4],
    radius: 8,
  },
};

export const comboConfig: CustomCombo = {
  options: comboOptions,

  afterUpdate(model, combo) {
    if (!model || !combo) return;
    combo?.toBack();
  },
};
